import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { VerificationComponent } from '../verification/verification.component';
import { environment } from 'src/environments/environment';
import { AddonSubscriptionService } from 'src/app/services/addon-subscription.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ProductService } from 'src/app/services/product.service';
import { CustomerfeedbackmanagementService } from 'src/app/services/customerfeedbackmanagement.service';
import { AppSettings } from 'src/app/enums/app-settings.enum';

@Component({
  selector: 'app-addon-card',
  templateUrl: './addon-card.component.html',
  styleUrls: ['./addon-card.component.scss'],
})
export class AddonCardComponent implements OnInit {
  @Input('sku') sku: any;
  @Input('product') product: any;
  @Input('index') index: any;
  @Input('cat') cat: any;
  @Input('addonType') addonType: any;
  @Input('roaming') roaming: any;
  @Input() isParentalControl: boolean;

  @Input('promotionCheck') promotionCheck:any;
  @Input('titleLength') titleLength: any;
  @Input('promotionLength') promotionLength: any;
  
  categoryDetail: any;
  addon: any;
  currentAccount: any;
  isTravelInsuranceAddon: Boolean;
  travelInsuranceLabel: String;
  recommendedAddonsSkus: any[];
  unsubscribe$: Subject<boolean> = new Subject();
  showArenaProTemplate: boolean;
  currentLanguage: string;
  subCategory: any;
  oldFreedom: boolean;
  isControlLine: boolean;
  newAddonCard: boolean = false;
  ismobileScreen: boolean = false;
  userAccounts: any;
  accountList: any;
  constructor(
    private SKUDS: SkuDataService,
    private route: Router,
    private modalController: ModalController,
    private AS: AccountService,
    private SS: SubjectService,
    private SDS: SessionDataService,
    private GAS: GoogleAnalyticsService,
    private UTS: UtilitiesService,
    private AddonSubS: AddonSubscriptionService,
    private appInitService: ApplicationInitializationService,
    private cdr: ChangeDetectorRef,
    private CFM: CustomerfeedbackmanagementService,
    private aRoute: ActivatedRoute,
  ) {
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.aRoute.queryParams.subscribe((q) => {
      this.subCategory = q && q?.subCategory || '';
      if (q && q.subCategory && q.subCategory === 'Njg=') {
        this.oldFreedom = true;
      }
      if (q && q.subCategory && q.subCategory === AppSettings.CONTROL_LINE) {
        this.isControlLine = true;
      }
        if (q && q?.newAddonCard) {
          this.newAddonCard = q?.newAddonCard;
        }
      });
    this.SS.sku.subscribe((main) => {
      if (main && main.name && main.value) {
        (this.addon = main.name), (this.categoryDetail = main.value);
      }
    });
    if (localStorage.getItem('currentAccount')) {
      const currentAccount = JSON.parse(localStorage.getItem('currentAccount'));
      if (currentAccount) {
        this.currentAccount = currentAccount;
      }
    }
    else{
      setTimeout(()=> {
        this.getAccount();
      }, 500)
    }
    this.SS.recommendedAddonsSkus.subscribe((r) => {
      if (r && r.length > 0) {
        this.recommendedAddonsSkus = [];
        this.recommendedAddonsSkus = r;
        for (let i = 0; i < this.recommendedAddonsSkus.length; i++) {
            const skuId = this.recommendedAddonsSkus[i];
            if (skuId == this.sku?.skuId) {
              const recommend = {
                recommended: true,
              };
              this.sku = { ...this.sku, ...recommend };
            }
        }
      }
    });
  }

  ngOnInit() {
    this.removingKeyBenefits();
    this.checkTravelInsuranceAddon();

    this.currentLanguage = this.UTS.getLocaleLanguage();
    const w = document.documentElement.clientWidth || window.innerWidth;
    if (w < 992) {
      this.ismobileScreen = true;
    } else {
      this.ismobileScreen = false;
    }
  }

  openDetailPage(sku: any, i: number) {
    if (this.isParentalControl) {
      if (i == 0) {
        window.location.href =
          environment.BASE_URL +
          `/smartHomeConfiguration?productId=${sku.productId}&skuId=${
            sku.skuId
          }&locale=${this.UTS.getLocaleLanguage().toLocaleLowerCase()}`;
      } else {
        this.route.navigateByUrl(
          `/parentalControlAddons/detail?productId=${sku.productId}&skuId=${
            sku.skuId
          }&lang=${this.UTS.getLocaleLanguage().toLocaleLowerCase()}`
        );
      }
    } else {
      this.SKUDS.set(sku);
      this.SDS.setAddon(this.addon);
      this.SS.resetVerification.next(true);
      setTimeout(() => {
        let catID = '';
        if (localStorage.getItem('CAT')) {
          catID = localStorage.getItem('CAT');
        }
        if (i == 0) {
          if (
            this.appInitService?.environmentConfig
              ?.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW == 'TRUE'
          ) {
            this.addonSubscriptionOption(sku);
          } else {
            this.subscribe(sku);
          }
        } else {
        if (this.roaming) {
          localStorage.setItem('isRoaming', 'true');
        }
        const navigationExtras: NavigationExtras = {
          state: {
           roaming: this.roaming,
          },
        };
        this.route.navigateByUrl(`/addon/detail?skuId=${sku.skuId}&lang=${
          this.UTS.getLocaleLanguage().toLocaleLowerCase()}`, navigationExtras);
        }
      }, 500);
    }

  }

  private subscribe(sku: any) {
    if (this.roaming) {
      localStorage.setItem('isRoaming', 'true');
    }
    const userInfo: any = this.AS.getUInfo();
    this.SS.skuDetails.next(sku);
    if (this.roaming) {
      this.openBottomSheet(VerificationComponent, {
        type: this.addonType,
        planName: this.sku?.displayName,
        roaming: true,
      });
    } else {
      this.openBottomSheet(VerificationComponent, { type: this.addonType });
    }
  }

  private addonSubscriptionOption(sku: any) {
    if (this.roaming) {
      localStorage.setItem('isRoaming', 'true');
    }
    this.SS.skuDetails.next(sku);
    
    if (
      this.sku?.productType?.toLowerCase() == 'arenagamingaddon' ||
      this.sku?.productType == 'ARENA_GAMING_ADDON'
    ) {
          this.showArenaProTemplate = true;
    }
    const userInfo: any = this.AS.getUInfo();
    if (userInfo) {
      const subCategoryId = localStorage.getItem('subCategoryId');
      this.AddonSubS.redirectionAddonSubscriptionPage(
        this.sku,
        this.roaming,
        subCategoryId ? subCategoryId : null,
        (this.showArenaProTemplate) ? true : false
      );
    } else {
      if (this.roaming) {
        this.openBottomSheet(VerificationComponent, {
          type: this.addonType,
          planName: this.sku?.displayName,
          roaming: true,
        });
      } else {
        this.openBottomSheet(VerificationComponent, { type: this.addonType });
      }
    }
  }

  async openBottomSheet(component: any, data) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      cssClass: 'verification-modal modal-fullscreen ion-modal-uplift eand-partail-height-screen-bottom-70-mobile',
    });
    return await modal.present();
  }

  public productClick() {
  this.GAS.productClick(
    this.cat,
    this.product?.value,
    this.sku?.displayName,
    this.sku?.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
    this.sku?.listPrice,
    this.index + 1,
    this.sku?.brand
  );
  localStorage.setItem(
    'ProductCategory',
    JSON.stringify({
      cat: this.cat,
      product: this.product?.value,
      position: this.index + 1,
})
);
  }
  removeDec(n) {
    if (!n || !Number(n)) return n;
    return Number(n);
  }

  removingKeyBenefits() {
    const data =
      (this.sku &&
        this.sku?.keyBenefits &&
        this.sku?.keyBenefits.filter(
          (x) => x?.unit !== 'roamingCountryList'
        )) ||
      [];
    if (this.sku && this.sku?.keyBenefits) {
      this.sku.keyBenefits = data;
    }
  }
  checkTravelInsuranceAddon() {
    if (this.sku && this.sku?.rewardList && this.sku?.rewardList?.length > 0) {
      this.sku.rewardList.forEach((item) => {
        if (item?.key && item?.key == 'travelInsurance') {
          this.isTravelInsuranceAddon = true;
          this.travelInsuranceLabel = item.value ? item.value : '';
        }
      });
    }
  }

  restrictString(str){
   return this.UTS.restrictString(str)
  }
  formatAmount(amount){
    return this.UTS.formatAmount(amount)
  }
  
  
  setStatusLabelColor(tile: any) {
    var style;
    if (tile && tile?.backgroundColor && tile?.backgroundColor.includes(',')) {
      style = {
        'background-image': 'linear-gradient(to left,' + tile?.backgroundColor + ')',
        color: tile?.textColor
      }
    }
    else {
      style = {
        'background-color': tile?.backgroundColor,
        color: tile?.textColor
      }
    }
    return style;
  }
  setPremiumLabelColor(tile) {
    if (tile && tile?.value && tile.value.toLowerCase() == 'bronze')
      return 'eand-bg-gradient-bronze';
    else if (tile && tile?.value && tile.value.toLowerCase() == 'gold' || tile && tile?.value && tile.value.toLowerCase() == 'gold plus')
      return 'eand-bg-gradient-gold';
    else if (tile && tile?.value && tile.value.toLowerCase() == 'standard' || tile && tile?.value && tile.value.toLowerCase() == 'silver plus' || tile && tile?.value && tile.value.toLowerCase() == 'silver')
      return 'eand-bg-gradient-silver';
    else if (tile && tile?.value && tile.value.toLowerCase() == 'platinum')
      return 'eand-bg-gradient-premuim';
  }
  trackCardGA(sku,event,sub_section) {
    let info = '';
    let info1 = '';
    let index = 0;
    if (sku?.keyBenefits && sku?.keyBenefits?.length && sku?.keyBenefits?.length > 0) {
      sku?.keyBenefits?.forEach((item) => {
        if (item && item?.key && item?.value && index <= 1) {
          if (index == 0) {
            info = item?.key + " " + item?.value + " " + item?.unit;
          }
          else {
            info1 = item?.key + " " + item?.value + " " + item?.unit;
          }
          index++;
        }
      });
    }
    this.GAS.AddonsCardTrackingGA(event, sku?.displayName, sub_section, info, info1, sku?.skuId, sku?.validity,sku?.listPrice);
  }

  onBuyClick(sku) {
    try {
      let userInfo = '';
      if (sessionStorage?.getItem('isLoggedIn') || sessionStorage?.getItem('isLoggedIn') == 'true') {
        userInfo = sessionStorage?.getItem('userId');
      }
      let info = '';
      let info1 = '';
      let iteration = 0;
      if (sku?.keyBenefits && sku?.keyBenefits?.length && sku?.keyBenefits?.length > 0) {
        sku?.keyBenefits?.forEach((item) => {
          if (item && item?.key && item?.value && iteration <= 1) {
            if (iteration == 0) {
              info = item?.key + " " + item?.value + " " + item?.unit;
            }
            else {
              info1 = item?.key + " " + item?.value + " " + item?.unit;
            }
            iteration++;
          }
        });
      }
      let items = [];
      let item = {
        item_id: sku?.skuId,// Capture the SKU ID of the plan
        item_name: sku?.displayName,
        device_type: this.UTS.getENV(),//App
        coupon: "nil", // Capture the coupon value if any else Nil
        discount: "nil", // Capture the discounted value if any else Nil
        index: 1,
        item_brand: "Etisalat",
        item_category: 'Addons',
        item_list_id: sku?.productId, // SKUID of Freedom live plans
        item_list_name: sku?.productName,
        price: sku?.listPrice, //Price of the plan
        currency: 'AED', // Currency
        quantity: '1',
        user_id: userInfo || '',// Capture user id . No PII data.
        info: info || '',
        info1: info1 || '',
        entry_point: window?.location?.pathname || '', //Dynamic Values
      }
      let index = 0;
      sku?.dynamicAttributesExtendedEn?.forEach(element => {
        index++;
        let key = "item_extras" + index;
        let value = element?.label;

        item[key] = value;
      });
      items?.push(item);
      let data = {
        event: 'select_item',
        ecommerce: {
          items: items
        }
      }
      this.GAS.productImpressionsOnSearch_Roaming(data);
    } catch (e) {
      console.log(e);
    }
  }
  
  keyBenefitsValue(kb){
    return (kb && !isNaN(kb?.value)) ? this.removeDec(kb?.value) + ' ' +  kb?.unit : kb?.value + ' ' +  kb?.unit
  }
  getAccount() {
    this.AS.getUserInfo().subscribe(
      (res) => {
        this.AS.getAllAccount().subscribe((resp) => {
          if (resp && resp?.userAccounts && resp?.userAccounts?.length > 0) {
            this.userAccounts = resp?.userAccounts;
            for (let i = 0; i < resp?.userAccounts.length; i++) {
              resp.userAccounts[i]['image'] =
                'data:image/png;base64,' + AppSettings.PROFILE_IMAGE;
            }
            this.accountList = JSON.parse(JSON.stringify(resp.userAccounts));
            for (let i = 0; i < resp?.userAccounts?.length; i++) {
              if (
                resp?.userAccounts[i] &&
                resp?.userAccounts[i]?.primary &&
                resp?.userAccounts[i]?.primary === true
              ) {
                resp.userAccounts[i]['image'] =
                  'data:image/png;base64,' + AppSettings?.PROFILE_IMAGE;
                const currentAccount = resp.userAccounts[i];
                this.currentAccount = currentAccount;
                localStorage.setItem(
                  'currentAccount',
                  JSON.stringify(currentAccount)
                );
              }
            }
          }
          if (
            this.userAccounts &&
            this.userAccounts?.length &&
            this.userAccounts?.length == 1
          ) {
            this.userAccounts[0]['image'] =
              'data:image/png;base64,' + AppSettings?.PROFILE_IMAGE;
            const currentAccount = this.userAccounts[0];
            this.currentAccount = currentAccount;
            localStorage.setItem(
              'currentAccount',
              JSON.stringify(currentAccount)
            );
          }
        });
      },
      (e) => {
        console.log(e);
      }
    );
  }
}
